import { Component } from '@angular/core';
import { ApiCallerService } from './services/api-caller.service';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs';

export class Answers {
  answer: string;
  question: number;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})



export class AppComponent {






  number = "";
  items: any[];

  testing : Answers[] = [];

  session: any[];
  teacherSetup = false;
  studentSetup = false;
  isTeacher = false;
  isStudent = false;
  historicalStep = false;
  sessionCreated = false;
  lastQuestion = false;

  reseted = false;


selectedUser(event) {
    if (event == "student") {
    	this.isStudent = true;
    }
    else {
    	this.isTeacher = true;
    }
  }



  setTrack(event) {
    this.teacherSetup = true;
    this.service.selectedTrack = event;
    this.service.currentQuestion = 1;
  }

  startStudentQuiz() {
    this.studentSetup = true;
  }
  stopStudentQuiz() {
    this.studentSetup = false;
  }
  startHistorical(){
    this.historicalStep = true;
    this.lastQuestion = false;
  }
  exitHistorical(event){
    if (event == 1) {
      this.lastQuestion = true;
    }
    this.historicalStep = false;




  }
  exitLast(){
    this.historicalStep = true;
    this.lastQuestion = false;
  }
 resetAll(){
  console.log("Resetted?!");
      this.teacherSetup = false;
      this.studentSetup = false;
      this.isTeacher = true;
      this.isStudent = false;
      this.historicalStep = false;
      this.sessionCreated = true;
      this.service.saveCode = true;
      this.lastQuestion = false;
      
      if (this.service.saveCode) {
        this.reseted = true;
      }
  }


  ngOnInit() {

// this.db.list('/Session-815275/connected').remove("student");

  // this.db.list('/Session-815275/active').push(1);

  }

  ngOnDestroy() {

  }



constructor(private service: ApiCallerService, private db: AngularFireDatabase) {}


}


